import { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Lock, Loader2, ArrowLeft } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate('/admin');
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-5" data-testid="admin-login-page">
      <a
        href="/"
        data-testid="login-back-home"
        className="absolute top-6 left-6 flex items-center gap-2 text-[#f1f0ea]/50 hover:text-acid transition-colors text-sm"
      >
        <ArrowLeft size={16} /> Volver a la web
      </a>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md border border-white/10 bg-surface p-8 sm:p-10"
      >
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 flex items-center justify-center bg-acid text-white">
            <Lock size={20} />
          </div>
          <div>
            <h1 className="font-heading uppercase text-2xl text-[#f1f0ea] leading-none">Panel Alfredj</h1>
            <p className="text-xs text-[#f1f0ea]/50 mt-1">Acceso privado de administración</p>
          </div>
        </div>

        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label className="block text-xs uppercase tracking-widest text-[#f1f0ea]/60 mb-2">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="username"
              className="w-full bg-ink border border-white/15 px-4 py-3 text-[#f1f0ea] focus:border-acid outline-none transition-colors"
              placeholder="tu@email.com"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-[#f1f0ea]/60 mb-2">Contraseña</label>
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              className="w-full bg-ink border border-white/15 px-4 py-3 text-[#f1f0ea] focus:border-acid outline-none transition-colors"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <p data-testid="login-error" className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 px-3 py-2">
              {error}
            </p>
          )}

          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-acid text-white font-heading uppercase text-lg py-3 hover:-translate-y-0.5 transition-transform disabled:opacity-60 flex items-center justify-center gap-2"
          >
            {loading ? <Loader2 className="animate-spin" size={20} /> : 'Entrar'}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
